"use strict";
// https://alpaca.markets/docs/trading-on-alpaca/orders/#order-lifecycle
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInForceEnum = exports.TradeTypeEnum = exports.DecisionStatusEnum = exports.TradeDecisionEnum = void 0;
var TradeDecisionEnum;
(function (TradeDecisionEnum) {
    TradeDecisionEnum["Buy"] = "buy";
    TradeDecisionEnum["Sell"] = "sell";
})(TradeDecisionEnum = exports.TradeDecisionEnum || (exports.TradeDecisionEnum = {}));
var DecisionStatusEnum;
(function (DecisionStatusEnum) {
    DecisionStatusEnum["Filled"] = "filled";
    DecisionStatusEnum["Expired"] = "expired";
    DecisionStatusEnum["Canceled"] = "canceled";
    DecisionStatusEnum["New"] = "new";
    DecisionStatusEnum["Open"] = "open"; // this is not an alpaca decision status, this is just for us
})(DecisionStatusEnum = exports.DecisionStatusEnum || (exports.DecisionStatusEnum = {}));
var TradeTypeEnum;
(function (TradeTypeEnum) {
    TradeTypeEnum["Market"] = "market";
    TradeTypeEnum["Limit"] = "limit";
    TradeTypeEnum["Stop"] = "stop";
    TradeTypeEnum["Stop_Limit"] = "stop_limit";
    TradeTypeEnum["Trailing_Stop"] = "trailing_stop";
})(TradeTypeEnum = exports.TradeTypeEnum || (exports.TradeTypeEnum = {}));
var TimeInForceEnum;
(function (TimeInForceEnum) {
    TimeInForceEnum["Day"] = "day";
    TimeInForceEnum["Gtc"] = "gtc";
    TimeInForceEnum["Opg"] = "opg";
    TimeInForceEnum["Cls"] = "cls";
    TimeInForceEnum["Ioc"] = "ioc";
    TimeInForceEnum["Fok"] = "fok";
})(TimeInForceEnum = exports.TimeInForceEnum || (exports.TimeInForceEnum = {}));
